import {useRefraManufacturersQuery} from './useRefraManufacturersQuery'

export const useRefraManufacturersOptions = () => {
  const {data: refraManufacturers, isFetching: areRefraManufacturersFetching} =
    useRefraManufacturersQuery()

  const refraManufacturersOptions =
    refraManufacturers?.map((manufacturer) => ({
      label: manufacturer.name,
      value: manufacturer.id
    })) ?? []

  return {refraManufacturersOptions, areRefraManufacturersFetching}
}
